import { Link } from "react-router-dom";
import { Phone, Mail, Facebook } from "lucide-react";

const FACEBOOK_URL = "https://www.facebook.com/search/top?q=Milo%20Liam%20Clarke";

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-14">
          <div>
            <div className="inline-block bg-brand-logo ring-1 ring-white/15 p-4 mb-5">
              <img src="/clarkes-logo.jpg" alt="Clarkes GroundCare" className="w-52" />
            </div>
            <p className="text-white/50 font-body text-sm max-w-xs leading-relaxed">
              Professional ground maintenance services across the majority of the North East of England.
            </p>
          </div>

          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-white/40 mb-5">Contact</p>
            <a href="tel:07770347944" className="flex items-center gap-3 text-white/80 hover:text-brand-orange transition-colors mb-3">
              <Phone size={16} className="text-brand-orange" /> 07770 347944
            </a>
            <a href="mailto:clarkegroundcare@gmail.com" className="flex items-center gap-3 text-white/80 hover:text-brand-orange transition-colors break-all">
              <Mail size={16} className="text-brand-orange shrink-0" /> clarkegroundcare@gmail.com
            </a>
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="inline-flex items-center gap-3 text-white/80 hover:text-brand-orange transition-colors mt-3">
              <Facebook size={16} className="text-brand-orange" /> Follow us on Facebook
            </a>
          </div>

          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-white/40 mb-5">Hours</p>
            <p className="text-white/80 font-body">Open Monday to Sunday</p>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="inline-block mt-6 text-xs text-white/40 hover:text-brand-orange transition-colors underline underline-offset-4"
            >
              Admin login
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-sm font-body">
            © {new Date().getFullYear()} Clarkes GroundCare. All rights reserved.
          </p>
          <p className="text-white/30 text-xs font-body">Professional Ground Maintenance Services</p>
        </div>
      </div>
    </footer>
  );
};
